module.exports = __webpack_public_path__ + "static/img/cover_image.e29c195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover_image.png
// module id = VgXy
// module chunks = 0